//Login expiration warning in seconds
export const LOGIN_EXPIRATION_WARNING = 60;
//Login expiration warning in seconds
export const LOGIN_EXPIRATION_TIMEOUT = 900;



// WEBPACK FOOTER //
// ./src/constants/LoginConfig.js